var _path, _rect, _rect2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5104 8.2047C17.1375 7.48727 15.6408 7 14.0899 7C9.57964 7 5.5288 11.1205 3.64275 13.039C3.31938 13.3679 3.05964 13.6321 2.87214 13.7997C2.75225 13.9065 2.75225 14.0935 2.87214 14.2003C3.06946 14.3766 3.34122 14.66 3.67996 15.0133C4.81009 16.1918 6.68586 18.1478 9.03104 19.5018L11.2437 16.8649C10.5075 16.1334 10.0517 15.12 10.0517 14.0003C10.0517 11.7702 11.8595 9.96206 14.0899 9.96206C14.9564 9.96206 15.7591 10.235 16.4169 10.6997L18.5104 8.2047ZM12.993 17.8877C13.3418 17.9859 13.7097 18.0385 14.0899 18.0385C16.3199 18.0385 18.1281 16.2303 18.1281 14.0003C18.1281 13.3713 17.9843 12.7759 17.7277 12.2451L20.2353 9.2567C22.0755 10.5354 23.5828 12.0685 24.5366 13.0387C24.8602 13.3678 25.1201 13.6321 25.3076 13.7997C25.4273 13.9067 25.4273 14.0937 25.3076 14.2003C25.1101 14.3767 24.8381 14.6603 24.4991 15.0139C22.6384 16.954 18.7582 21 14.0899 21C12.9736 21 11.9025 20.7687 10.8932 20.3902L12.993 17.8877Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0371,
    y: 16.486,
    width: 1.16879,
    height: 7.35304,
    rx: 0.584393,
    transform: "rotate(40 10.0371 16.486)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3086,
    y: 4.24438,
    width: 1.16879,
    height: 7.08855,
    rx: 0.584393,
    transform: "rotate(40 20.3086 4.24438)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0223 12.3619C14.7473 12.205 14.4289 12.1153 14.0897 12.1153C13.0487 12.1153 12.2051 12.9591 12.2051 13.9999C12.2051 14.4571 12.3679 14.8762 12.6386 15.2026L15.0223 12.3619Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBlock);
export default __webpack_public_path__ + "static/media/ViewBlock.90769d3a82989e9abc1dd96411a492d0.svg";
export { ForwardRef as ReactComponent };